
export default function heroValuesSlider () {

	const swipers = document.querySelectorAll('section.hero-values-slider .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	const swiperInstances = [];

	function initSwipers () {
		// Destroy existing instances
		swiperInstances.forEach(swiper => swiper.destroy());
		swiperInstances.length = 0;

		swipers.forEach(function (container) {

			const section = container.closest('section');

			swiperInstances.push(new Swiper (container, {
				loop: false,
				breakpoints: {
					0: {
						centeredSlides: true,
						slidesPerView: 1.5,
						spaceBetween: 48
					},
					600: {
						centeredSlides: false,
						slidesPerView: 2,
						spaceBetween: 48
					},
					1024: {
						centeredSlides: false,
						slidesPerView: 3,
						spaceBetween: 72
					},
					1360: {
						centeredSlides: false,
						slidesPerView: 4,
						spaceBetween: 96,
					//	initialSlide: 1
					},
				},
				pagination: {
					el: section.querySelector('.swiper-pagination'),
					type: 'progressbar',
				},
				navigation: {
					prevEl: section.querySelector('.swipe-prev'),
					nextEl: section.querySelector('.swipe-next'),
				},
			}));

		});

	}

	// Initial init
	initSwipers ();

	// Reinit on resize (with debounce to avoid excessive recreation)
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout (resizeTimeout);
		resizeTimeout = setTimeout (initSwipers, 200);
	});

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too. ACF's block-preview JS runs in the outer
	admin window, while this script runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=hero-values-slider', heroValuesSlider);
}
